module.exports = __webpack_public_path__ + "static/media/3.327dc8f5.webp";